import React, { Fragment } from 'react';

import {
} from '../../../library/constants';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import './index.css';
import Checkbox from 'antd/lib/checkbox';


export class Options extends React.Component {

  customNodeStageCanBeClickedTouchedHovered = true;
  checkedBoxes = [];

  componentDidMount(){

    const showPicturesLabel = ( typeof(window.trl) !== 'undefined' ? window.trl(`Show photos.`, 'Hide option choices', null):`Show photos.`);
    const showEditLabel = ( typeof(window.trl) !== 'undefined' ? window.trl(`Show edit icon.`, 'Hide option choices', null):`Show edit icon.`);
    const showEmailInviteLabel = ( typeof(window.trl) !== 'undefined' ? window.trl(`Show email invite.`, 'Hide option choices', null):`Show email invite.`);

    this.checkBoxOptions = [
      { label: showPicturesLabel, value: 'showCardPhotos', width: 10},
      { label: showEditLabel, value: 'showCardEditIcon', width: 10},
      { label: showEmailInviteLabel, value: 'showCardEmailInvite', width: 10},
    ];

    this.checkBoxOptions.forEach((optionObj)=>{
      const value = optionObj.value;
      const optionServerChecked = this.props[value];
      if(typeof(optionServerChecked) !== 'undefined'){
        this.checkedBoxes.push(optionObj.value)
      }
    })

    console.log(`this.checkedBoxes: `, JSON.stringify(this.checkedBoxes, null, 2));

  }

  onChange(arrayOfChecked){

    let customStylesObj = {
      1:{
        selectedtheme: this.props.presetCustomObj.selectedtheme,
        fontSizeChoice: this.props.presetCustomObj.fontSizeChoice,
        custom: this.props.presetCustomObj.custom
      }
    }

    const optionsObj = {};
    arrayOfChecked.forEach((option)=>{
      optionsObj[option] = true;
    });

    customStylesObj[1] = {...customStylesObj[1], options: optionsObj}

    this.props.setOptionsForTree({newCustomStylesFromPreferences: customStylesObj})

    let postObj = {
      callback: () => {},
      skipReloadCanvasTree: true,
      styles: JSON.stringify(customStylesObj),
    };

    this.props.postPreferences(postObj);

  }

  render() {


    const optionsTitle = ( typeof(window.trl) !== 'undefined' ? window.trl('Elements to Display', 'Preferences Options', null): 'Elements to Display');

    return (

      <Fragment>

                  <Row>
                    <span style={{fontWeight: 'bold'}}>{optionsTitle}:</span><br/><br/>
                  </Row>
                  <Row>
                    <Col span={16} style={{ paddingLeft: 5 }}>


                    <div
                      id="optionCheckboxGroup"
                      style={{
                        width: `100%`,
                        height: 'auto',
                        position: 'absolute',
                        top: '0px',
                        // right: '0px',
                      }}><Checkbox.Group
                            options={this.checkBoxOptions}
                            defaultValue={this.checkedBoxes}
                            onChange={this.onChange.bind(this)}
                          />
                    </div>

                    </Col>
                  </Row>
        <div>

        </div>
      </Fragment>
    )

  }
}



